/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description Zoe - Sparkle icon
 */
import React from 'react'
import sparkle from '../../../img/sparkle.svg'
import type { ImgIconProps } from '../../../types'

export const ZoeSparkle = ({
  alt = 'ask Zoe',
  size = 32,
  ...props
}: ImgIconProps) => (
  <img
    alt={alt}
    height={size}
    loading="lazy"
    width={size}
    src={sparkle}
    {...props}
  />
)
